module.exports = __webpack_public_path__ + "img/shopping-app.e3414cb0.svg";